
































import { Component, Mixins } from 'vue-property-decorator';
import NotificationsManager from '@/components/NotificationsManager.vue';
import { readIsLoggedIn } from '@/store/main/getters';
import { dispatchCheckLoggedIn } from '@/store/main/actions';
import UpdateMixin from '@/mixins/UpdateMixin';

@Component({
  components: {
    NotificationsManager
  }
})
export default class App extends Mixins(UpdateMixin) {
  get loggedIn() {
    return readIsLoggedIn(this.$store);
  }

  get theme() {
    return this.$vuetify.theme.dark ? 'dark' : 'light';
  }

  public setTheme() {
    const theme = localStorage.getItem('dark_theme');
    if (theme) {
      if (theme === 'true') {
        this.$vuetify.theme.dark = true;
      } else {
        this.$vuetify.theme.dark = false;
      }
    } else if (
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches
    ) {
      this.$vuetify.theme.dark = true;
      localStorage.setItem('dark_theme', this.$vuetify.theme.dark.toString());
    }
  }

  public async created() {
    await dispatchCheckLoggedIn(this.$store);
  }

  public mounted() {
    this.setTheme();
  }
}
